<template>
  <a-modal :title="title" :width="width" :visible="visible" :maskClosable="false" :confirmLoading="confirmLoading"
    @ok="handleOk" :okText="this.$store.getters.language['common.okButton']" @cancel="handleCancel"
    :destroyOnClose="true" :cancelText="this.$store.getters.language['common.closeButton']">
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">

        <a-form-model-item :label="this.$store.getters.language['sys.SysCategoryList.parentNode']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="pid">
          <j-tree-select ref="treeSelect" :placeholder="this.$store.getters.language['common.pleaseInput'] +this.$store.getters.language['sys.SysCategoryList.parentNode']" v-model="model.pid" dict="sys_category,name,id"
            pidField="pid" pidValue="0" :disabled="disabled">
          </j-tree-select>
        </a-form-model-item>

        <a-form-model-item :label="this.$store.getters.language['sys.SysCategoryList.name']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
          <a-input v-model="model.name" :placeholder="this.$store.getters.language['common.pleaseInput'] +this.$store.getters.language['sys.SysCategoryList.name']"></a-input>
        </a-form-model-item>

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>

import { httpAction, getAction } from '@/api/manage'
import JTreeSelect from '@/components/jeecg/JTreeSelect'

export default {
  name: "SysCategoryModal",
  components: {
    JTreeSelect
  },
  data() {
    return {
      title: this.$store.getters.language['common.action'],
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },

      confirmLoading: false,
      validatorRules: {
        pid: {},
        name: [{ required: true, message: this.$store.getters.language['common.pleaseInput'] + this.$store.getters.language['sys.SysCategoryList.name'] }]
      },
      url: {
        add: "/sys/category/add",
        edit: "/sys/category/edit",
        checkCode: "/sys/category/checkCode",
      },
      expandedRowKeys: [],
      pidField: "pid",
      subExpandedKeys: []

    }
  },
  created() {
  },
  computed: {
    disabled() {
      return this.model.id ? true : false;
    },
    language() {
      return this.$store.getters.language
    },
  },
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.model = Object.assign({}, record);
      this.visible = true;
    },
    close() {
      this.$emit('close');
      this.visible = false;
      this.$refs.form.resetFields();
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'put';
          }
          httpAction(httpurl, this.model, method).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              // close的时候清空了表单的值 导致model为空 修改值在列表页没有变 此处需要复制一下model
              that.submitSuccess({ ...this.model })
            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
            that.close();
          })
        } else {
          return false;
        }

      })
    },
    handleCancel() {
      this.close()
    },
    submitSuccess(formData) {
      if (!formData.id) {
        let treeData = this.$refs.treeSelect.getCurrTreeData()
        this.expandedRowKeys = []
        this.getExpandKeysByPid(formData[this.pidField], treeData, treeData)
        if (formData.pid && this.expandedRowKeys.length == 0) {
          this.expandedRowKeys = this.subExpandedKeys;
        }
        this.$emit('ok', formData, this.expandedRowKeys.reverse());
      } else {
        this.$emit('ok', formData);
      }
    },
    getExpandKeysByPid(pid, arr, all) {
      if (pid && arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].key == pid) {
            this.expandedRowKeys.push(arr[i].key)
            this.getExpandKeysByPid(arr[i]['parentId'], all, all)
          } else {
            this.getExpandKeysByPid(pid, arr[i].children, all)
          }
        }
      }
    },

  }
}
</script>